import(/* webpackMode: "eager" */ "/builds/magic.ai/frontend/magicsquare/apps/store-web/styles/global.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/magic.ai/frontend/magicsquare/libs/shared/src/common/components/ErrorPage/ErrorPage.tsx");
